export default __webpack_public_path__ + "static/media/flip-the-rules.2da23b14.jpg";